<div class="ts-table-container">
  <ag-grid-angular
    [rowData]="rowData"
    [rowSelection]="rowSelection"
    [columnDefs]="colDefs"
    [suppressDragLeaveHidesColumns]="suppressDragLeaveHidesColumns"
    [suppressRowClickSelection]="suppressRowClickSelection"
    [gridOptions]="gridOptions"
    [getRowId]="getRowId"
    [stopEditingWhenCellsLoseFocus]="true"
    [tooltipShowDelay]="tooltipShowDelay"
    [loadingOverlayComponent]="customLoadingParams?.show ? loadingOverlayComponent : undefined"
    [loadingOverlayComponentParams]="customLoadingParams"
    (cellClicked)="onCellClicked($event)"
    (cellEditingStopped)="onCellEditingStopped($event)"
    (sortChanged)="onSortChanged($event)"
    (gridReady)="onGridReady($event)"
    (columnMoved)="handleColumnMove($event)"
    (dragStopped)="onDragStopped($event)"
    (rowDragEnd)="onRowDragEnd($event)"
    (rowDragMove)="onRowDragMove($event)"
    (rowDragLeave)="onRowDragLeave($event)"
    (firstDataRendered)="firstDataRendered($event)"
    (cellValueChanged)="onCellValueChanged($event)"
    (selectionChanged)="onSelectionChanged($event)"
    (gridColumnsChanged)="onGridColumnsChanged($event)"
    (virtualColumnsChanged)="onVirtualColumnsChanged($event)"
    (columnResized)="onColumnResized($event)"
    (cellEditingStarted)="onCellEditingStarted($event)"
    (columnPinned)="columnPinned.emit($event)"
    (rowDataUpdated)="onRowDataUpdated($event)"
    [domLayout]="autoHeight ? 'autoHeight' : 'normal'"
    [animateRows]="animateRows"
  >
  </ag-grid-angular>
</div>
